<template>
  <div v-if="show" class="custom-inline-panel" 
  :style="{
     top: `${top + currentScrollTop}px`,
     left: `${left + currentScrollLeft}px`,
     position: 'absolute'
   }">
    <div class= "max-h-[264px] overflow-auto flex flex-col rounded-md shadow-md p-[0.8rem] bg-white w-[282px] mx-auto ">
    

        <!-- Header Section -->
        <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
         
          <h3 class="text-[17px] font-semibold">Edit Pipeline</h3>
          
       
          <!-- <a
            href="#"
            @click.prevent="navigateToAddNewStatus"
            class="text-blue-500 text-sm font-medium hover:underline add-new-state-link mb-[5px]"
          >
            (+ Add New Status)
          </a>
          <fluent-icon
           v-tooltip="'If you want to add new status, click on (+ Add New Status) link.'"
            icon="info"
            size="16"
           class="info-color has-tooltip mb-[5px]"
          /> -->
        </div>
      </div>

      <div class="mt-[0.4rem]">
  <input
    v-model="search"
    type="text"
    class="search-input w-full border border-gray-300 rounded-md px-1.5 py-0.5 text-sm mb-2"
    placeholder="Search pipeline..."
  />
</div>

<div class="mt-2 max-h-40 overflow-y-auto">
  <LabelDropdownItem
    v-for="state in filteredStatuss"
    :key="state.id"
    :title="state.name"
    :color="state.color"
    :selected="statusId === state.id"
    @click="selectStatus(state.id)"
  />
  <div
    v-if="noResult"
    class="text-sm text-gray-600 dark:text-white px-2 py-4 text-center"
  >
  No results found
  </div>
</div>


<div class="flex gap-2 mt-[0.6rem] justify-end">
  <span 
    v-if="selectedStatusName"
    class="ml-2 px-2 py-[0.15rem] text-sm inline-flex items-center max-w-[200px] overflow-hidden"
  >
    <span class="text-gray-800 font-medium truncate max-w-[150px] overflow-hidden whitespace-nowrap">
      {{ selectedStatusName }}
    </span>
  </span>

  <button 
    class="cancel-btn px-4 py-2 rounded border cursor-pointer" 
    @click.prevent="onCancel"
  >
    {{ $t('CONTACT_FORM.FORM.CANCEL') }}
  </button>
</div>
   </div>
   </div>
</template>
  
  <script>
import Editor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import alertMixin from 'shared/mixins/alertMixin';
import LabelDropdownItem from 'shared/components/ui/label/LabelDropdownItem.vue';
import { mapGetters } from 'vuex';
import { picoSearch } from '@scmmishra/pico-search';
export default {
  components: {
    Editor,
    LabelDropdownItem,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    status_id: {
      type: Number,
      default: null,
    },
    contactId: {
      type: Number,
      default: null,
    },
    board_id: {
       type: Number,
       default: null
    },
    top: Number,
    left: Number,
    currentScrollLeft: { type: Number, default: 0 },
    currentScrollTop: { type: Number, default: 0 }
  },
  mixins: [alertMixin],
  watch: {
    status_id(newVal) {
      this.statusId = newVal;
      if(newVal!=null){
        console.log("Status ID changed:", this.statusId);
        this.getStatusData(newVal);
      }
      else{
        this.stateId=null;
        this.remark=''
      }
    },

    board_id: {
      immediate: true, // run on first load too
      handler(board_id) {
        if (this.board_id) {
          console.log("called watcher",this.board_id);
          this.fetchStatuses(this.board_id);
          console.log("Board ID1",this.board_id);
        }
        else {
      console.log("Board ID is null, clearing status ID");
      this.statusId = null;
    }
      }
    },
    show(newVal) {
      if (newVal) {
        this.isModalOpening = true;
        this.$nextTick(() => {
          setTimeout(() => {
            this.isModalOpening = false;
            document.addEventListener('click', this.handleOutsideClick);
          }, 100);
        });
      } else {
        document.removeEventListener('click', this.handleOutsideClick);
      }
    },

  },
  data() {
    return {
      remark: '',
      statusId: null,
      progress: false,
      originalStatusId: null,  
      originalRemark: '',
      search: '',
      statuss: [],
      isInitialLoad: true,
    };
  },
  mounted() {
    this.setInitialValues();
    this.$store.dispatch('pipelines/getState');
    this.fetchStatuses(this.board_id)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick); // NEW
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId', // Getter to fetch accountId from Vuex
    }),
    status() {
      return this.$store.getters['pipelines/getAllState'];
    },
  filteredStatuss() {
  if (!this.search) {
    let newresults = this.statuss.filter(status => status.id !== this.statusId);
    return newresults.filter(status => status.agent_dragable == true || this.currentUser.role == 'administrator');
  }
  const results = picoSearch(this.statuss, this.search, ['name'], { threshold: 0.9 });
  let newresults = results.filter(status => status.id !== this.statusId);
  return newresults.filter(status => status.agent_dragable == true || this.currentUser.role == 'administrator');
},
    noResult() {
    return this.filteredStatuss.length === 0 && this.search.trim() !== '';
  },
    selectedStatusName() {
      const state = this.statuss.find(s => s.id === this.statusId);
      return state ? state.name : '';
    },
    formHasChanged() {
      return (
        this.statusId !== this.originalStatusId || 
        this.remark !== this.originalRemark
      );
    },
  },
  methods: {
    handleOutsideClick(event) {
      if (!this.show || this.isModalOpening) return;
      const modalElement = this.$el;
      if (modalElement && !modalElement.contains(event.target)) {
        this.onCancel();
      }
    },
    selectStatus(id) {
    this.statusId = id;
    this.onStatusChange();
  },
    navigateToAddNewStatus() {
      // Get the base URL dynamically from the current window location
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      
      // Ensure accountId is valid
      if (!this.accountId) {
        console.error("Account ID is undefined");
        return;
      }
      
      // Construct the URL dynamically using accountId
      const url = `${baseUrl}/app/accounts/${this.accountId}/settings/status?showAddStatus=true`;

      // Open the dynamically generated URL in a new tab
      this.onCancel();
      window.open(url, "_blank");
    },
    onCancel() {
       this.search = ''
       document.removeEventListener('click', this.handleOutsideClick);
      this.$emit('cancel');
    },
    async getStatusData(status_id) {
      const data={
        id: status_id,
        contact_id: this.contactId
      }
      const response = await this.$store.dispatch(
        'pipelines/UpdateStatus',
        data
      );
      console.log("Response",response);
      if (response.data.status_description !== null) {
        this.remark = response.data.status_description;
      }
      else{
        this.remark='';
      }

      this.setInitialValues();
    },
    setInitialValues() {
      this.originalStatusId = this.statusId;
      this.originalRemark = this.remark;
    },
    async editStatus() {
      this.progress=true;
      const data = {
        statusId: this.statusId,
        contactId: this.contactId,
        description: this.remark,
      };
      const response = await this.$store.dispatch(
        'pipelines/assignStatus',
        data
      );
      bus.$emit('on-assign');
      if (response.status == 200) {
        this.showAlert('Status Update Successfully', { success: true });
      }
      this.onCancel();
      this.progress=false;
    },
    async removeStatus() {
      this.progress = true;
      const data = {
        statusId: null, // Set statusId to null to remove the status
        contactId: this.contactId,
        description: '',
      };
      const response = await this.$store.dispatch(
        'pipelines/assignStatus',
        data
      );
      bus.$emit('on-assign');
      if (response.status == 200) {
        this.showAlert('Status Removed Successfully', { success: true });
      }
      this.onCancel();
      this.progress = false;
    },
    async fetchStatuses(id) {
      try {
        const response = await axios.get(
          `/api/v1/accounts/${this.accountId}/statuses`,
          {
            headers: {
              'Content-Type': 'application/json',
              'api-access-token': this.currentUser.access_token,
            },
            params:{
              board_id: this.board_id
            }
          }
        );
        this.statuss= response.data.data;
        console.log("Statuses fetched:", this.statuss);
        // return this.statuss;
      } catch (error) {
        console.error('Error fetching statuses:', error);
        // throw error;
        console.error("Error fetching statuses:", error);
      } 
    },
    async onStatusChange() {
      if (this.statusId) {
        console.log("Status is being updated:", this.statusId);
        await this.editStatus();
      }
    },
  },
};
</script>
  
<style lang="scss" scoped>
.custom-inline-panel {
  z-index: 1; // Ensure modal appears above table content
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2); // Make modal stand out
}

.justify-item {
  justify-content: space-around;
}
.button-color {
  background-color: #40518a;
}
.color {
  color: #40518a;
}
.editor-ui {
  border: 2px solid lightgrey;
  height: 200px;
  padding-left: 10px;
  margin: 0px 7px;
}
.cancel-btn{
  background-color: #fff;
  color: #40518a;
}
.cancel-btn:hover{
  background-color: #F9F9F9;
  color: #40518a;
}
/* Padding for Header */
.px-8 {
  padding-left: 1rem;
}

/* Styling for Add New State Link */
.add-new-state-link {
  // position: absolute;
  // top: 45px;
  // left: 143px;
  color: #40518a;
  font-size: 0.875rem; /* text-sm */
  font-weight: 500; /* font-medium */
  text-decoration: none;
}

.add-new-state-link:hover {
  text-decoration: underline;
  color: #0056b3;
}

/* Styling for Info Icon */
.info-icon-1 {
  position: absolute;
  top: 45px;
  right: 308px;
  color: black;
}

.info-icon:hover {
  color: #40518a;
}
.info-color{
  color:black;
}
.board-list {
  max-height: 10rem;
  overflow-y: auto;
}

.cancel-cross:hover{
  background-color: #F9F9F9;
}

.dark .text-gray-800 {
  color: #3C4858;
}
</style>